import { ethers } from 'ethers'
import { formatUnits } from 'ethers/lib/utils'
import React, { useEffect, useState } from 'react'
import Button from '../components/Button'
import Input from '../components/Input'
import Section from '../components/Section'
import { toast } from 'react-hot-toast'
import { isJSON } from '../utils'
import Web3 from 'web3'
import Providers from './../providers/index';
import {
    ContractCallContext,
    ContractCallResults,
    Multicall as EtherMulticall,
} from "ethereum-multicall";
import { MULTICALL_ADDRESSES } from '../utils/constants'
let web3: Web3 | undefined = undefined
function Multicall() {
    const [contractAddress, setContractAddress] = useState('')
    const [multicallAddress, setMulticallAddress] = useState('')
    const [callData, setCallData] = useState('')
    const [abi, setAbi] = useState('')
    const [output, setOutput] = useState('')
    useEffect(() => {
        if (!web3) {
            try {
                (window as any).ethereum.enable().then(() => {
                    web3 = new Web3((window as any).ethereum)
                    web3.eth.getChainId().then((chainId: any) => {
                        if (MULTICALL_ADDRESSES.hasOwnProperty(chainId)) {
                            setMulticallAddress(MULTICALL_ADDRESSES[chainId as keyof typeof MULTICALL_ADDRESSES])
                        }
                    })
                })
            } catch (error: any) {
            }
        }
    }, [])
    const callFunction = async () => {
        if (!web3) {
            try {
                await (window as any).ethereum.enable()
                web3 = new Web3((window as any).ethereum)
            } catch (error: any) {
                toast.error(error.toString())
                return;
            }
        }

        if (!contractAddress || !multicallAddress || !abi) {
            toast.error('Please enter data and contract address/ multicall address/ abi')
            return
        }
        if (!isJSON(abi)) {
            toast.error('Abi is invalid JSON format')
            return
        }
        try {
            let inputs: any[] = []
            if (callData) {
                inputs = JSON.parse(callData);
            }
            const jsonAbi = JSON.parse(abi);
            let params: any[] = [];
            for (const i of inputs) {
                const param = {
                    reference: i,
                    contractAddress: contractAddress,
                    abi: jsonAbi,
                    calls: [
                        {
                            reference: jsonAbi[0].name,
                            methodName: jsonAbi[0].name,
                            methodParameters: i,
                        },
                    ],
                };
                params.push(param);
            }
            const multicall = new EtherMulticall({
                web3Instance: web3,
                tryAggregate: true,
                multicallCustomContractAddress: multicallAddress,
            });
            const contractCallContext: ContractCallContext[] = params;
            const results: ContractCallResults = await multicall.call(
                contractCallContext
            );
            const resultData = results?.results;
            let output: any = {};
            if (resultData) {
                for (const key in resultData) {
                    if (resultData[key].callsReturnContext[0].success) {
                        let arrOutput: any[] = []
                        for (const iterator of resultData[key].callsReturnContext[0].returnValues) {
                            if (iterator['type'] === "BigNumber") {
                                arrOutput.push({ number: Number(iterator['hex']), ...iterator })
                            }
                            else {
                                arrOutput.push(iterator);
                            }
                        }
                        output[key] = arrOutput;
                    }
                }
            }
            setOutput(JSON.stringify(output))
        } catch (ie: any) {
            setOutput(`Internal error: ${ie.stack}`)
        }
    }

    return (
        <>
            <div className="container">
                <div className="input-field parse-input">
                    <Input
                        className="method-input__value"
                        onChange={(e) => {
                            setContractAddress(e.target.value)
                        }}
                        value={contractAddress}
                        placeholder="Contract address"
                        type="text"
                        name="data"
                    />
                </div>
                <div className="input-field parse-input">
                    <Input
                        className="method-input__value"
                        onChange={(e) => {
                            setMulticallAddress(e.target.value)
                        }}
                        value={multicallAddress}
                        placeholder="Multicall address"
                        type="text"
                        name="data"
                    />
                </div>
                <div className="input-field parse-input">
                    <Input
                        className="method-input__value"
                        onChange={(e) => {
                            setCallData(e.target.value)
                        }}
                        value={callData}
                        placeholder="Topics (optional, each seperated by a comma)"
                        type="text"
                        name="topic"
                    />
                </div>
                <div className="section encoded-section">
                    <textarea
                        className="method-input__value"
                        placeholder="Abi (JSON array)"
                        rows={20}
                        cols={40}
                        autoComplete="off"
                        onChange={(e) => {
                            setAbi(e.target.value)
                        }}
                        value={abi}
                    />
                </div>

                <div className="section-choose__buttons">
                    <Button className="add-param" onClick={callFunction}>
                        Call
                    </Button>
                </div>
                <Section className="encoded-section">
                    <textarea
                        readOnly
                        placeholder="Output"
                        rows={20}
                        cols={40}
                        autoComplete="off"
                        value={output}
                    />
                </Section>
            </div>
        </>
    )
}

export default Multicall
